import { render, staticRenderFns } from "./PageNoticeList.vue?vue&type=template&id=050863fa&scoped=true&"
import script from "./PageNoticeList.vue?vue&type=script&lang=ts&"
export * from "./PageNoticeList.vue?vue&type=script&lang=ts&"
import style0 from "./PageNoticeList.vue?vue&type=style&index=0&id=050863fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050863fa",
  null
  
)

export default component.exports